import React from 'react';
import Dsy from './dsyui';
import { createComponent } from '@lit-labs/react';

const LitComp = Dsy.components.DsyHeading;

export const DsyHeading = createComponent(
  React,
  'dsy-heading',
  LitComp,
  {},
);
